import UpdatePasswordMutation from '@jetshop/core/data/mutations/updatePassword.gql';
import logError from '@jetshop/core/helpers/logError';
import t from '@jetshop/intl';
import { Form, Formik } from 'formik';
import React from 'react';
import { useMutation } from '@apollo/react-hooks';
import { createValidatorForFields } from './formFieldsFromSettings';
import { useCustomerQuery } from './useCustomer';
import GetCustomerCountryCode from '@jetshop/core/data/queries/GetCustomerCountryCode.gql';
const inputProps = {
    oldPassword: {
        type: 'password',
        name: 'oldPassword',
        required: true,
        autoComplete: 'current-password'
    },
    newPassword: {
        type: 'password',
        name: 'newPassword',
        required: true,
        autoComplete: 'new-password'
    },
    repeatPassword: {
        type: 'password',
        name: 'newPasswordRepeat',
        required: true,
        autoComplete: 'new-password'
    }
};
export const UpdatePasswordProvider = ({ render, onSubmitSuccess }) => {
    const updatePasswordMutation = useUpdatePasswordMutation();
    // We need the user's country code so we can check the validation rules in
    // that country's channel settings
    const { countrySettings } = useCustomerQuery({
        query: GetCustomerCountryCode
    });
    const passwordField = countrySettings &&
        countrySettings.privateCustomerFields.find(field => field.name === 'password');
    // Combine validation from the API with our own validation
    const validator = createValidatorForFields([
        passwordField,
        { id: 'oldPassword', name: 'oldPassword', required: true },
        { id: 'newPasswordRepeat', name: 'newPasswordRepeat', required: true }
    ], {
        getFieldName: name => {
            if (name === 'password') {
                return 'newPassword';
            }
            return name;
        },
        customValidation: (errors, values) => {
            if (values.newPasswordRepeat &&
                values.newPassword !== values.newPasswordRepeat) {
                errors.newPasswordRepeat = t('Does not match new password');
            }
        }
    });
    return (React.createElement(Formik, { initialValues: {
            oldPassword: '',
            newPassword: '',
            newPasswordRepeat: ''
        }, validate: validator, onSubmit: ({ newPassword, oldPassword }, actions) => {
            actions.setSubmitting(true);
            updatePasswordMutation({ newPassword, oldPassword })
                .then(() => {
                actions.setSubmitting(false);
                actions.resetForm();
                typeof onSubmitSuccess === 'function' && onSubmitSuccess();
                actions.setStatus({ success: true });
            })
                .catch(err => {
                logError(true, err);
                actions.setSubmitting(false);
                actions.setStatus({
                    globalError: t('Something went wrong updating password. Is your old password correct?')
                });
            });
        }, render: props => {
            var _a, _b;
            return (React.createElement(Form, null, render(Object.assign(Object.assign({}, props), { inputProps, submitted: (_a = props === null || props === void 0 ? void 0 : props.status) === null || _a === void 0 ? void 0 : _a.success, globalError: (_b = props === null || props === void 0 ? void 0 : props.status) === null || _b === void 0 ? void 0 : _b.globalError }))));
        } }));
};
export function useUpdatePasswordMutation() {
    const [mutate] = useMutation(UpdatePasswordMutation);
    return function updatePasswordMutationWrapper(variables) {
        return Promise.resolve()
            .then(() => mutate({
            variables
        }))
            .then(res => {
            if (!res.data.updatePassword.success) {
                // This should never happen as mutation itself fails
                throw new Error('Something went wrong');
            }
        });
    };
}
//# sourceMappingURL=UpdatePasswordForm.js.map